webpackJsonp([145],{

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(886);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("6ce5bba2", content, true, {});

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".Card1 amp-img{width:100%}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/Card1/src/components/contents/Card1/Card1.s.scss"],"names":[],"mappings":"AAEA,eAEI,UAAW,CACZ","file":"Card1.s.scss","sourcesContent":["@import '~scss/variables';\n\n.Card1 {\n  amp-img {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/145.e909071ebae754b03474.js